import React, {useState} from "react";
import {Grid, Col} from "../../../../styles/Grid";
import styled from "styled-components";
import {Input} from "../../../../styles/Forms";
import Color from "../../../../assets/colors";

export default function SessionsList({data, change, addClass, deleteTheme, deleteClass, changeClass}) {
   const [titleToDelete, setTitleToDelete] = useState(false);
   let {title, id, subclass, valid} = data;

   return (
      <>
         <AllGrid className={titleToDelete ? "willRemove" : ""}>
            <ColTitle large={11}>
               <TitleText
                  type="text"
                  className={valid === true ? "valid" : valid === false ? "invalid" : ""}
                  value={title}
                  onChange={(e) => change(id, "title", e.target.value)}
               />
               <button
                  className="removeItem"
                  onMouseOver={() => {
                     setTitleToDelete(true);
                  }}
                  onMouseLeave={() => {
                     setTitleToDelete(false);
                  }}
                  onClick={() => deleteTheme(id)}
               >
                  X
               </button>
            </ColTitle>
            <Col large={11}>
               <SubclassList>
                  {React.Children.toArray(
                     subclass.map((item) => (
                        <SubclassItem>
                           <NormalText
                              type="text"
                              value={item.name}
                              onChange={(e) => {
                                 changeClass(id, item.id, e.target.value);
                              }}
                           />
                           <button
                              className="removeItem"
                              onClick={() => {
                                 deleteClass(id, item.id);
                              }}
                           >
                              X
                           </button>
                        </SubclassItem>
                     )),
                  )}
               </SubclassList>
            </Col>
            <Col>
               <button onClick={() => addClass(id)}>Agregar</button>
            </Col>
         </AllGrid>
      </>
   );
}

SessionsList.defaultProps = {
   title: "Titulo",
   content: [{name: "Dato 1"}, {name: "Dato 2"}],
};

const AllGrid = styled(Grid)`
   transition: all 420ms;
   margin-bottom: 1em;

   // border-bottom: 2px solid #32529d;
   /* border-right: 2px solid white;
   border-left: 2px solid white;
 */
   &.willRemove {
      opacity: 0.4;
      // background: rgb(10, 10, 10, 0.2);
      transition: all 420ms;
   }
`;

const ColTitle = styled(Col)`
   display: flex;
   align-items: center;

   & .removeItem {
      color: crimson;
      background: white;
      margin-left: 0.5em;
      border-radius: 50%;
      font-size: 1em;
      width: 1.3em;
      height: 1.3em;
      text-align: center;
      transition: all 420ms;

      &:hover {
         color: white;
         background: crimson;
         transition: all 420ms;
      }
   }
`;

const TitleText = styled(Input)`
   font-weight: 200;
   margin: 0.5em 0;
   font-size: 1em;
   padding: 0.3em;

   &.valid {
      border-bottom-color: green;
   }

   &.invalid {
      border-bottom-color: crimson;
      background-color: crimson;
   }
`;

const SubclassList = styled.ul`
   padding-left: 1em;
`;
const SubclassItem = styled.li`
   display: flex;
   align-items: center;
   margin-bottom: 0.5em;

   .removeItem {
      color: crimson;
      background: white;
      margin-left: 0.5em;
      // padding: 0.3em;
      border-radius: 50%;
      font-size: 1em;
      width: 1.3em;
      height: 1.3em;
      text-align: center;

      &:hover {
         color: white;
         background: crimson;
      }
   }
`;

const NormalText = styled(Input)`
   font-weight: 200;
   margin: 0;
   margin-bottom: 0.7em;
   font-size: 0.95em;
   padding: 0.2em;
   // background: red;
`;

const DeleteButton = styled.button`
   color: crimson;
   background: white;
   margin-left: 0.5em;
   // padding: 0.3em;
   border-radius: 50%;
   font-size: 1em;
   width: 1.3em;
   height: 1.3em;
   text-align: center;

   &:hover {
      color: white;
      // background: crimson;
      background: blue;
   }
`;
